import React, { Component } from "react";
import Dashboard from "../../components/Dashboard/Dashboard";
import CrawlErrors from "../../components/CrawlErrors/CrawlErrors";
import axios from "axios";
import { Loader } from "semantic-ui-react";
import { Route, Switch } from "react-router-dom";

class Main extends Component {
  state = {
    errors: null,
    sites: {},
    isLoading: false,
    allCrawlErrors: {},
    validCrawlErrors: {}
  };

  componentDidMount() {
    this.fetchWebsites();
  }

  fetchWebsites = () => {
      this.setState({isLoading: true})
    let token = this.props.token;
    axios
      .get(
        `https://www.googleapis.com/webmasters/v3/sites?access_token=${token}`
      )
      .then(response => {
        this.setState({
          ...this.state,
          sites: response.data.siteEntry,
          isLoading: false
        });
        console.log(response);
        this.fetchAllCrawlErrors();
      })
      .catch(err => {
        console.log(err.response.data.error);
        this.setState({
          ...this.state,
          errors: err.response.data.error,
          isLoading: false
        });
      });
  };

  fetchAllCrawlErrors = () => {
      this.setState({isLoading: true})
    const allSites = this.state.sites;

    allSites.map(site => {
      const token = this.props.token;
      let protocol = "https";
      let website = site.siteUrl;
      let domain = website;
      if (website.slice(0, 7) === "http://") {
        domain = website.slice(7, -1);
        protocol = "http";
      } else {
        domain = website.slice(8, -1);
      }

      return axios
        .get(
          `https://www.googleapis.com/webmasters/v3/sites/${protocol}%3A%2F%2F${domain}/urlCrawlErrorsCounts/query?access_token=${token}`
        )
        .then(response => {
          let errorCount = 0;
          response.data.countPerTypes.map(i => {
            errorCount += Number(i.entries[0].count);
          });
          let convertedName = "";
          convertedName = site.siteUrl.replace(/(^\w+:|^)\/\/www./, "");
          convertedName.slice(0, -1)
          const singleCrawlError = {
            siteName: site.siteUrl,
            domainName: convertedName,
            data: response.data.countPerTypes,
            count: errorCount,
            error: null
          };

          this.setState({
            ...this.state,
            isLoading: false,
            allCrawlErrors: [...this.state.allCrawlErrors, singleCrawlError],
            validCrawlErrors: [...this.state.validCrawlErrors, singleCrawlError]
          });
        })
        .then(response => {
            this.props.history.push("/dashboard")
            this.setState({ isLoading: false })
        })
        .catch(err => {
          const singleCrawlError = {
            siteName: site.siteUrl,
            data: null,
            error: err.response.data.error
          };
          console.log(err.response.data.error);
          this.setState({
            allCrawlErrors: [...this.state.allCrawlErrors, singleCrawlError]
          });
        });
    });
  };

  render() {
    let view = <Loader size="large" content="Loading" active />;
    if (!this.state.isLoading) {
      view = (
        <Switch>
          <Route
            exact
            name="dashboard"
            path="/dashboard"
            render={props => (
              <Dashboard
                {...props}
                sites={this.state.sites}
                allCrawlErrors={this.state.allCrawlErrors}
                validCrawlErrors={this.state.validCrawlErrors}
                token={this.props.token}
                user={this.props.user}
                isLoading={this.state.isLoading}
              />
            )}
          />
          <Route
            path="/crawl-errors"
            render={props => (
              <CrawlErrors
                {...props}
                sites={this.state.sites}
                allCrawlErrors={this.state.allCrawlErrors}
                validCrawlErrors={this.state.validCrawlErrors}
                token={this.props.token}
                user={this.props.user}
                isLoading={this.state.isLoading}
              />
            )}
          />
        </Switch>
      );
    }

    return (
      <section className="MainContent">
            {view}
      </section>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/containers/Main/Main.js